import http from "../http-common";

class LoginService {
  login(data: any) {
    return http.post(`/crm/login`, data);
  }
}
export default new LoginService();
